import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const PageTitle = ({ children, noMargin }) => (
  <Box mb={noMargin ? 0 : 2}>
    <Typography variant="h5">{children}</Typography>
  </Box>
);

PageTitle.defaultProps = {
  children: null,
  noMargin: false,
};

PageTitle.propTypes = {
  children: PropTypes.node,
  noMargin: PropTypes.bool,
};

export default PageTitle;
